import './HeaderListingPage.css';
import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import getListing from '../../utils/getListing';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { get, canUseDOM, getDictionaryItem } from '../../utils';
import { headerImageStyle } from '../57_HeaderArticle1/HeaderArticle1';
import { qsToObject } from '../../utils/querystring';
import { useHistory } from 'react-router-dom';
import DarkThemeControl from '../BrightcoveVideosAtoms/DarkThemeControl';
const HeaderListingPage = _ref => {
  let {
    fields,
    params
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const algoliaSettings = {
    key: get(sitecoreContext, 'configuration.algolia.algoliaApiKey'),
    id: get(sitecoreContext, 'configuration.algolia.algoliaApplicationId'),
    fullTextSearchIndex: get(sitecoreContext, 'configuration.algolia.fullTextSearchIndex')
  };
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const isSharedCh = get(params, 'RenderingStyle') === 'Shared Channels' || false;
  let pageName = get(fields, 'data.item.headerTag.jss');
  const dotSite = get(sitecoreContext, 'site.name');
  const darkMode = get(sitecoreContext, 'darkMode');
  const actions = get(sitecoreContext, 'actions', {});
  const dictionary = get(fields, 'data.dictionary');
  const darkModeTitle = getDictionaryItem(dictionary, 'dark mode') || '';
  const {
    changeThemeFunction = () => {}
  } = actions;
  let history = useHistory();
  if (dotSite === 'dotsite') {
    pageName = get(fields, 'data.item.pageName');
  }
  const pageTitle = get(fields, 'pageTitle') || get(fields, 'data.item.pageTitle');
  const pageTitleValue = get(fields, 'pageTitle.value') || get(fields, 'data.item.pageTitle.value');
  const pageIntro = get(fields, 'pageIntro') || get(fields, 'data.item.pageIntro.value');
  const Color = get(params, 'Color') || '';
  const GradientColor = get(params, 'GradientColorHex');
  let gradient = null;
  const [heightGradien, setHeightGradien] = React.useState(0);
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ColorHex = get(params, 'ColorHex');
  const isMobile = canUseDOM ? window.matchMedia(`(max-width: 992px)`).matches : false;
  // const headerTag = get(fields, 'pageIntro')

  if (BackgroundColorHex && BackgroundColorHex.length && GradientColor && GradientColor.length && !isSharedCh) {
    gradient = isSharedCh ? null : "hxinbc7";
  }
  if (BackgroundColorHex && BackgroundColorHex.length && GradientColor && GradientColor.length && isSharedCh) {
    gradient = "hidx6nx";
  }
  const variables = BackgroundColorHex ? {
    '--m57-Generic-Tertiary-title-color': ColorHex,
    '--m57-Generic-Tertiary-intro-color': ColorHex,
    '--m57-Generic-Tertiary-background-color': BackgroundColorHex
  } : {
    '--m57-Generic-Tertiary-title-color': '#000',
    '--m57-Generic-Tertiary-intro-color': '#505050',
    '--m57-Generic-Tertiary-background-color': '#fff'
  };
  const variablesSharedCh = BackgroundColorHex ? {
    '--m57-Generic-Tertiary-title-color': ColorHex,
    '--m57-Generic-Tertiary-intro-color': ColorHex,
    '--m57-Generic-Tertiary-background-color': BackgroundColorHex
  } : {
    '--m57-Generic-Tertiary-title-color': '#000',
    '--m57-Generic-Tertiary-intro-color': '#40484F',
    '--m57-Generic-Tertiary-background-color': 'linear-gradient(180deg, #fff 0%, #DDE2EB 100%)'
  };
  const [state, setstate] = React.useState('');
  React.useEffect(() => {
    if (canUseDOM) {
      if (Color && Color.length && GradientColor && GradientColor.length && !isSharedCh) {
        if (typeof window !== 'undefined') {
          if (document.querySelector('.filter__wrapper')) {
            // @ts-ignore
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            setHeightGradien(document.querySelector('.filter__wrapper').offsetHeight);
          }
        }
      }
      // qsToObject
      const queryParams = qsToObject(history.location.search);
      let curatorID = '';
      if (queryParams['curators.curators.Id']) {
        curatorID = queryParams['curators.curators.Id'].toLowerCase();
        let itemFilter = {
          hitsPerPage: 1,
          facetFilters: [['type:Curator'], [`objectID:${curatorID}`]]
        };
        getListing(get(params, 'SearchIndex'), itemFilter, algoliaSettings).then(hits => {
          setstate(hits && hits.hits[0].title);
        });
      }
    }
  }, []);
  if (!fields) {
    console.warn('HeaderListingPage component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [HeaderListingPage component is empty: please provide data source]");
    }
    return null;
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    className: `${isSharedCh && GradientColor && gradient && GradientColor.length ? gradient : ''}`,
    rtl: rtl,
    isSharedCh: isSharedCh,
    style: {
      '--startColor': BackgroundColorHex,
      '--endColor': GradientColor
    }
  }, Color && Color.length && GradientColor && GradientColor.length && !isSharedCh ? /*#__PURE__*/React.createElement("span", {
    className: `${gradient}`,
    style: {
      height: isMobile ? '464px' : '700px'
    }
  }) : '', /*#__PURE__*/React.createElement("div", {
    className: `container ${BackgroundColorHex && BackgroundColorHex.length && !GradientColor && !isSharedCh ? 'styled-wrapper' : ''}`,
    style: isSharedCh ? variablesSharedCh : variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "header header-generic--secondary"
  }, /*#__PURE__*/React.createElement("div", {
    className: `module-group ${isSharedCh ? '' : 'no-padding-bottom'}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "dark-mode-switcher-box"
  }, !isSharedCh && /*#__PURE__*/React.createElement("div", {
    className: "col-md-1 col-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: isSharedCh ? '' : 'col-md-7 col-7'
  }, params && params['Dark Mode Switcher Show'] && /*#__PURE__*/React.createElement(DarkThemeControl, {
    handleClick: changeThemeFunction,
    label: darkModeTitle,
    value: darkMode,
    params: params
  }))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, !isSharedCh && /*#__PURE__*/React.createElement("div", {
    className: "col-xl-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: isSharedCh ? 'header-generic--wrapper col-xl-12' : 'col-xl-11'
  }, pageName && pageName.value && /*#__PURE__*/React.createElement("div", {
    className: "header__category"
  }, /*#__PURE__*/React.createElement(Text, {
    className: "c-category__text",
    tag: "span",
    field: pageName
  })), /*#__PURE__*/React.createElement("div", {
    className: "header__title"
  }, pageEditing && /*#__PURE__*/React.createElement(Text, {
    tag: "h1",
    field: pageTitle,
    className: "h2 c-title__text"
  }), !pageEditing && /*#__PURE__*/React.createElement("h1", {
    className: "h2 c-title__text"
  }, `${pageTitleValue} ${state}`), pageIntro && isSharedCh && /*#__PURE__*/React.createElement("div", {
    className: "p header__content",
    dangerouslySetInnerHTML: {
      __html: pageIntro
    }
  }))))), !isSharedCh && /*#__PURE__*/React.createElement("div", {
    className: "module-group no-padding-top"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-11"
  }, pageIntro && /*#__PURE__*/React.createElement("div", {
    className: "p header__content",
    dangerouslySetInnerHTML: {
      __html: pageIntro
    }
  })))))))));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    className,
    style = {},
    isSharedCh
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    className: `${isSharedCh ? commonSharedChStyles : commonStyles} ${rtl ? isSharedCh ? rtlSharedChStyles : rtlStyles : isSharedCh ? ltrSharedChStyles : ltrStyles} ${className} ${headerImageStyle}`
  }, children);
};
export const commonStyles = "c4hg9i7";
export const commonSharedChStyles = "cxrl9pd";
export const ltrStyles = "l1ae33cq";
export const ltrSharedChStyles = "l1311ikl";
export const rtlStyles = "r1lta8yd";
export const rtlSharedChStyles = "rjbokq6";
export default HeaderListingPage;